import { render } from "./market-trades-block.vue?vue&type=template&id=3e336f2e&scoped=true"
import script from "./market-trades-block.vue?vue&type=script&lang=js"
export * from "./market-trades-block.vue?vue&type=script&lang=js"

import "./market-trades-block.vue?vue&type=style&index=0&id=3e336f2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e336f2e"]])

export default __exports__